<template>
  <v-card class="pa-2 mt-3" outlined flat>
    <v-form>
      <v-container>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="items.individualName"
              label="Individual Served Name"
              :outlined="outlined"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="items.caseNo"
              label="Case #"
              :outlined="outlined"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="items.monthYear"
              label="Month/Year"
              :outlined="outlined"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="items.provider"
              label="Provider"
              :outlined="outlined"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="items.homeAddress"
              label="Address of Home"
              :outlined="outlined"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-sheet elevation="1" class="pa-5">
              <table>
                <thead>
                  <tr>
                    <td>
                      <div class="text-center text-body-2 font-weight-bold">
                        Date <br />
                        mm/dd/yr
                      </div>
                    </td>
                    <td>
                      <div class="text-center text-body-2 font-weight-bold">
                        Area of Protective Oversight <br />
                        <span class="caption"
                          >Other must include description</span
                        >
                      </div>
                    </td>
                    <td>
                      <div class="text-center text-body-2 font-weight-bold">
                        Start Time <br />
                        00:00 <br />
                        AM/PM
                      </div>
                    </td>
                    <td>
                      <div class="text-center text-body-2 font-weight-bold">
                        End Time <br />
                        00:00 <br />
                        AM/PM
                      </div>
                    </td>
                    <td>
                      <div class="text-center text-body-2 font-weight-bold">
                        Total Time <br />
                        <span class="caption"
                          >Other must include description</span
                        >
                        <br />
                      </div>
                    </td>
                    <td>
                      <div class="text-center text-body-2 font-weight-bold">
                        Staff Initial
                      </div>
                    </td>
                    <td>
                      <div class="text-center text-body-2 font-weight-bold">
                        Individual Initials
                      </div>
                    </td>
                    <td v-if="items.timesheets.length < 1">
                      <div class="text-center text-body-2 font-weight-bold">
                        Action
                      </div>
                    </td>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(item, i) in items.timesheets" :key="i">
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field
                          v-model="item.date"
                          :outlined="outlined"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </td>
                    <td width="40%">
                      <div class="d-flex pa-2 chk">
                        <div class="d-flex chk items">
                          <v-checkbox
                            v-model="item.chkMedical"
                            value="No"
                            label="Medical"
                            class="mr-2"
                          ></v-checkbox>
                          <v-checkbox
                            v-model="item.chkJDT"
                            value="No"
                            label="JDT Absence"
                            class="mr-2"
                          ></v-checkbox>
                          <v-checkbox
                            v-model="item.chkOther"
                            value="No"
                            label="Other"
                          ></v-checkbox>
                        </div>
                        <div class="chk field">
                          <v-text-field
                            v-model="item.other"
                            :outlined="outlined"
                            dense
                            hide-details
                          ></v-text-field>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field
                          v-model="item.start"
                          :outlined="outlined"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field
                          v-model="item.end"
                          :outlined="outlined"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field
                          v-model="item.totalTime"
                          :outlined="outlined"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </td>

                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field
                          v-model="item.staffInitial"
                          :outlined="outlined"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </td>

                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field
                          v-model="item.individualInitial"
                          :outlined="outlined"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </td>

                    <td v-if="items.timesheets.length > 1" class="text-center">
                      <div class="pa-2">
                        <v-btn
                          color="error"
                          dark
                          right
                          class=""
                          @click="removeTimesheet"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="d-flex justify-end mt-5">
                <v-btn
                  color="warning"
                  dark
                  right
                  class=""
                  @click="clearTimesheetItems"
                >
                  clear
                </v-btn>
                <div class="ma-1"></div>
                <v-btn
                  color="primary"
                  dark
                  right
                  class=""
                  @click="addTimesheet"
                >
                  add
                </v-btn>
              </div>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-sheet elevation="1" class="pa-5">
              <table>
                <thead>
                  <td colspan="3">
                    <div class="text-center text-body-2 font-weight-bold pa-5">
                      Area of Protective Oversight
                    </div>
                  </td>
                </thead>
                <thead>
                  <tr height="50px">
                    <td>
                      <div class="text-center text-body-2 font-weight-bold">
                        Staff Initial
                      </div>
                    </td>
                    <td>
                      <div class="text-center text-body-2 font-weight-bold">
                        Staff Printed Name
                      </div>
                    </td>

                    <td v-if="items.staffs.length < 1" width="5%">
                      <div class="text-center text-body-2 font-weight-bold">
                        Action
                      </div>
                    </td>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(item, i) in items.staffs" :key="i">
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field
                          v-model="item.initial"
                          :outlined="outlined"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field
                          v-model="item.name"
                          :outlined="outlined"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </td>
                    <td v-if="items.staffs.length > 1" class="text-center">
                      <div class="pa-2">
                        <v-btn
                          color="error"
                          dark
                          right
                          class=""
                          @click="removeStaff(i)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div  class="d-flex justify-end mt-5">
                <v-btn
                  color="warning"
                  dark
                  right
                  class=""
                  @click="clearStaffItems"
                >
                  clear
                </v-btn>
                <div class="ma-1"></div>
                <v-btn  v-if="items.staffs.length < 5" color="primary" dark right class="" @click="addStaff">
                  add
                </v-btn>
              </div>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>
<script>
/*eslint-disable */
export default {
  props: {
    items: Object
  },
  data() {
    return {
      outlined: true,
      // items: {
      //   timesheets: [{}],
      //   staffs: [{}],
      // },
    };
  },
  methods: {
    
    getItems(){
      return this.items
    },

    getData() {
      return this.flattenArrays({
        ...this.items,
        totalTime: this.calculateTotalHours().toString(),
      });
    },

    addTimesheet() {
      this.items.timesheets.push({});
    },
    removeTimesheet(i) {
      this.items.timesheets.splice(i, 1);
    },
    addStaff() {
      this.items.staffs.push({});
    },
    removeStaff(i) {
      this.items.staffs.splice(i, 1);
    },
    clearTimesheetItems() {
      this.items.timesheets = [[]];
    },
    clearStaffItems() {
      this.items.staffs = [[]];
    },
    flattenArrays(data) {
      const flattened = {};

      Object.entries(data).forEach(([key, value]) => {
        if (!Array.isArray(value)) {
          flattened[key] = value;
        } else {
          value.forEach((item, index) => {
            Object.entries(item).forEach(([innerKey, innerValue]) => {
              flattened[`${innerKey}${index + 1}`] = innerValue;
            });
          });
        }
      });

      return flattened;
    },

    calculateTotalHours() {
      return this.items.timesheets.reduce((total, timesheet) => {
        const hours = parseInt(timesheet.totalTime, 10);
        return total + (isNaN(hours) ? 0 : hours);
      }, 0);
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 1.5rem;
  font-weight: 400;
}

.fab--btn {
  display: "absolute";
  bottom: 10px;
}

.fab--btn.delete {
  right: calc(-100% + 20px);
}

.fab--btn.delete.custome {
  right: calc(-100% + -10px);
  top: 40px;
}

/* table design */
table {
  border-collapse: collapse !important;
}

table,
th,
td {
  border: 1px solid;
}

table {
  width: 100%;
}

.chk {
  justify-content: center;
}

.chk.field {
  align-self: center;
  margin-left: 10px;
}
</style>
